<div class="desabonnement">
  <div class="container content">
    <h3 class="text-uppercase accent">Demande de désabonnement</h3>
    <div *ngIf="!reponse">
      <p>Votre email <strong>{{email}}</strong> a été enregistré pour communiquer avec vous concernant vos biens à vendre, vos recherches ou le traitement de vos demandes.</p>
      <p>Etes-vous sûr de vouloir vous désinscrire de nos services ?</p>
      <div class="my-3">
        <button class="btn btn-gold px-4 py-2" (click)="desabonnement()">Oui</button>&nbsp;
        <button class="btn btn-gold px-4 py-2" (click)="goAccueil()">Non</button>
      </div>
    </div>

    <div *ngIf="reponse">
      <p>Votre demande de désinscription a bien été prise en compte.</p>
    </div>
  </div>
</div>
